import React from "react";
import styles from "./forum_welcome.module.scss";

const ForumWelcome = () => {
  return (
    <div className={styles.welcome_wrapper}>
      <h2 className={styles.heading}>Welcome to UniSearch Forum</h2>
      <p className={styles.text}>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. In montes,
        enim, massa metus.
      </p>
    </div>
  );
};

export default ForumWelcome;
